import {Info} from 'react-feather'
import React from "react"
import {store} from '@csrc/redux/storeConfig/store'

export const quickLinks = [
  {
    title: 'office.nav.officeRegistration',
    route: '/office/registration',
    permission: 'OFC_VIEW_OFFICE_REGISTER',
    visible: () => {
      const office = store.getState().dashboard.services.office
      return !office.belongToOffice
    },
    icon: () => {
      const office = store.getState().dashboard.services.office
      return office.hasOfficePendingRequest && (
        <span className="position-absolute" style={{ right: '15px' }}>
          <Info size='16' className="text-warning"/>
        </span>
      )
    }
  },
  {
    title: 'office.nav.officeList',
    route: '/office/list',
    permission: 'OFC_VIEW_OFFICE_LIST',
    visible: () => true
  },
  {
    title: 'office.nav.officeWaitingApproval',
    route: '/office-waiting-approval/list',
    permission: 'OFC_VIEW_OFFICE_WAITING_APPROVAL',
    visible: () => true
  },
  {
    title: 'office.nav.editMyOffice',
    route: '/office/my-office/profile',
    permission: 'OFC_VIEW_MY_OFFICE_PROFILE',
    visible: () => true
  }
]
